import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddToHospital, FilterDataRecords, Hospital } from '../../models';
import { environment } from '../../../environments/environment';
import { StatusHospital } from 'src/app/consts';

@Injectable({
  providedIn: 'root'
})
export class HospitalService {

  constructor(
    private http: HttpClient
  ) { }

  public getAll(date: string, filterData?: FilterDataRecords) {
    let queries = '?date=' + date;

    if (filterData) {
      let serviceIds: Array<string> = [];
      filterData.services.forEach((service) => {
        if (service.selected) {
          serviceIds.push(service.id.toString());
        }
      });

      let vetIds: Array<string> = [];
      filterData.vets.forEach((vet) => {
        if (vet.selected) {
          vetIds.push(vet.id.toString());
        }
      });
      queries = queries + '&ordering=' + filterData.sortField + '&statuses=' + filterData.statuses.join(',') + '&service_types=' + serviceIds.join(',') + '&specialist_ids=' + vetIds.join(',');
    }

    return this.http.get<{
      code: string;
      data: Array<Hospital>
    }>(`${environment.host}/hospital/${queries}`);
  }

  public getById(id: number) {
    return this.http.get<{
      code: string;
      data: Hospital
    }>(`${environment.host}/hospital/${id}`);
  }

  public discharge(hospitalId: number) {
    return this.http.put<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/hospital/${hospitalId}/change_status`, {
      status: 'discharged'
    });
  }

  public add(data: AddToHospital) {
    const formData = new FormData();
    for(let i=0; i < data.files.length; i++) {
      const file: any = data.files[i];
      if (file) {
        formData.append('files[' + i + ']file', file);
      }
    }
    formData.append('admission_date', data.admission_date);
    formData.append('discharge_date', data.discharge_date);
    formData.append('pet', data.pet.toString());
    formData.append('treatment', data.treatment);
    formData.append('diagnosis', data.diagnosis);
    formData.append('veterinarian', data.veterinarian.toString());
    formData.append('user', data.user?.toString() || '');

    return this.http.post<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/hospital/create/`, formData);
  }

  public updateStatus(id: number, status: StatusHospital) {
    return this.http.put<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/hospital/${id}/change_status`, {
      status
    });
  }
}
